export const IconUserComputer = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M3.66 4h17.083c.804 0 1.458.667 1.458 1.487v11.475c0 .82-.654 1.488-1.458 1.488H14.36c.098.426.358 1.117 1.052 1.824a.43.43 0 0 1 .09.463.42.42 0 0 1-.385.263H9.285a.42.42 0 0 1-.385-.263.43.43 0 0 1 .09-.463c.692-.706.959-1.397 1.062-1.824H3.66c-.805 0-1.459-.667-1.459-1.488V5.488C2.201 4.668 2.855 4 3.66 4m.208 11.05h16.667V5.7H3.867z" />
      <path d="M12.201 10.5q.825 0 1.413-.588.587-.587.587-1.412 0-.824-.587-1.412A1.93 1.93 0 0 0 12.2 6.5q-.825 0-1.412.588A1.93 1.93 0 0 0 10.2 8.5q0 .825.588 1.412.587.588 1.412.588m4 3v-.4q0-.425-.219-.781a1.46 1.46 0 0 0-.58-.544 7.4 7.4 0 0 0-1.576-.581 6.9 6.9 0 0 0-3.25 0 7.4 7.4 0 0 0-1.575.581 1.46 1.46 0 0 0-.581.544 1.47 1.47 0 0 0-.219.781v.4q0 .412.294.706a.96.96 0 0 0 .706.294h6q.412 0 .706-.294a.96.96 0 0 0 .294-.706" />
    </svg>
  );
};
